import { useContext } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import FutureExitContext from 'pages/ValuationsAllocation/approaches/FutureExit/utils/FutureExitContext';
import { filteredMultipleListStyles } from './FutureEquityLists.styles';

const FilteredMultipleSelect = (props: any) => {
  const { multipleOptions } = useContext(FutureExitContext);

  return (
    <GridSelect
      enumerated
      extraStyles={filteredMultipleListStyles}
      menuPosition="absolute"
      options={multipleOptions}
      {...props}
    />
  );
};

export default FilteredMultipleSelect;
